<div class="rating-tracks-select__select-box">
  <mat-form-field appearance="outline" bmTheme="color-customizer">
    <mat-label>{{ lg.sortTrackBy.adminSettings.label }}</mat-label>
    <mat-select [(value)]="defaultBeatsSorting" (selectionChange)="sortTracks($event)">
      <mat-option [value]="BeatsSortBy.OrderNumber">{{ lg.sortTrackBy.adminSettings.options.default }}</mat-option>
      <mat-option [value]="BeatsSortBy.ChartTop">{{ lg.sortTrackBy.adminSettings.options.top }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- Messages block -->
<p
  class="rating-tracks-select__message"
  [ngClass]="{ 'rating-tracks-select__message--error  bm--cut': responseMessage.status === 'error' }"
>
  {{ responseMessage.message }}
</p>
